// axios
import axios from "axios";

export const CheckPaymentStatus = async (data: any) => {
    let ClientOption: any = {
        headers: {
            'APIKEY': "zPSBbzwkalFSRchnnZwfvbydZ8Qzs9ZepMGakIG9D7jEL5BtXyreJNypxDro",
        }
    };
    const { data: response } = await axios.post(`${process.env.REACT_APP_API_URL}user/payment/verify?success=${data.success}&status=${data.status}&trackId=${data.trackId}`, {}, ClientOption);
    console.log(response)
    return response;
}

export const CheckPaymentStatusWallet = async (data: any) => {
    let ClientOption: any = {
        headers: {
            'APIKEY': "zPSBbzwkalFSRchnnZwfvbydZ8Qzs9ZepMGakIG9D7jEL5BtXyreJNypxDro",
        }
    };
    const { data: response } = await axios.post(`${process.env.REACT_APP_API_URL}user/wallet/transaction/verify?success=${data.success}&status=${data.status}&trackId=${data.trackId}`, {}, ClientOption);
    console.log(response)
    return response;
}


export const checkBothPayments = async (params: any) => {
  try {
    const [res1, res2] = await Promise.allSettled([
      CheckPaymentStatus(params),
      CheckPaymentStatusWallet(params),
    ]);

    if (res1.status === 'fulfilled' && res1.value?.status === 200) {
      return res1.value;
    }
    if (res2.status === 'fulfilled' && res2.value?.status === 200) {
      return res2.value;
    }

    throw new Error('پرداخت موفقیت‌آمیز نبود یا خطا رخ داده است.');

  } catch (error) {
    throw error;
  }
};
